function customSelect() {
	const placeholderDefault = 'Seleccione una opción...';
	const selects = jQuery('[data-select-custom="select"]');

	jQuery.each(selects, function () {
		let select = jQuery(this);
		let data = {
			fath: select.find('.select'),
			input: select.find('input[type="hidden"]'),
			select: select.find('.select__content'),
			placeholder: select.find('.select__placeholder'),
			options: select.find('.select__option')
		};

		renderSelectCustom(data);
		

		/**
		 * Toggle Select With Input
		 */
		data.placeholder.on('click', function () {
			if (data.select.hasClass('is--open')) {
				closeSelect(data);
			} else {
				openSelect(data);
			}

			data.options = select.find('.select__option');
		});
		
		
		/**
		 * Option Event
		 */
		data.options.on('click', function () {
			let value = ($(this).attr('data-value') != undefined) ? $(this).attr('data-value') : '';
			setValue(data, value);
			renderSelectCustom(data);
			closeSelect(data);
		});
		
		
		/**
		 * Close Select Click Outzone
		 */
		jQuery(document).click(function (e) {
			if (!select.is(e.target) && select.has(e.target).length === 0) {
				closeSelect(data);
			}
		});
	});


	/**
	 * Render Status Select
	 * @param {object} data 
	 */
	function renderSelectCustom(data) {
		let value = data.input.val();
		let selected = data.options.filter(`[data-value="${value}"]`).first();
		let placeholder = (selected.length > 0) ? selected.text() : placeholderDefault;

		data.options.removeClass('is--active');
		selected.addClass('is--active');
		data.placeholder.html(`<span>${placeholder}</span>`);
	}


	/**
	 * Open Options
	 * @param {object} data 
	 */
	function openSelect(data) {
		data.fath.addClass('is--focus');
		data.select.addClass('is--open');
	}


	/**
	 * Close Options
	 * @param {object} data 
	 */
	function closeSelect(data) {
		data.fath.removeClass('is--focus');
		data.select.removeClass('is--open');
	}


	/**
	 * Set Input Value
	 * @param {object} data 
	 * @param {*} value 
	 */
	function setValue(data, value) {
		data.input.val(value).trigger('change');;
	}
}

function cuzSelect(element) {
	
	let data = {};

	data.selector = element;
	
	data.setValue = function (value) {
		data.value = value;
		data.selector.val(data.value);
	};

	data.renderSelect = function () {
		let options = data.selector.siblings('.select').find('.select__option');
		let placeholder = data.selector.siblings('.select').find('.select__placeholder');
		
		let selected = options.filter(`[data-value="${data.value}"]`).first();
		let placeholder_text = (selected.length > 0) ? selected.text() : 'Seleccionar';

		options.removeClass('is--active');
		selected.addClass('is--active');
		placeholder.html(`<span>${placeholder_text}</span>`);
	}

	data.closeSelect = function () {
		data.fath.removeClass('is--focus');
		data.select.removeClass('is--open');
	}

	data.renderOptions = function () {
		let options = data.selector.siblings('.select').find('.select__option');

		data.fath = data.selector.siblings('.select');
		data.select = data.fath.find('.select__content');

		options.on('click', function () {
			let value = ($(this).attr('data-value') != undefined) ? $(this).attr('data-value') : '';
			data.setValue(value);
			data.renderSelect();
			data.closeSelect();
		});
	}

	return data;

}